export class ReportIdDef {
  public static readonly ARTICLE_LIST_REPORT_ID: string = 'ArticleList1';
  public static readonly POSITION_ARTICLE_LIST_REPORT_ID: string = 'PositionArticleList';
  public static readonly PROJECT_3D_REPORT_ID: string = 'ProjectDraft3D';
  public static readonly MULTIVIEW_REPORT_ID: string = 'MultiviewDraft';
  public static readonly DATA_SHEET_REPORT_ID: string = 'McsGdsDataSheetDraft';

  public static readonly NOT_SCALED_REPORT_IDS: string[] = [ReportIdDef.ARTICLE_LIST_REPORT_ID, ReportIdDef.POSITION_ARTICLE_LIST_REPORT_ID,
    ReportIdDef.PROJECT_3D_REPORT_ID, ReportIdDef.MULTIVIEW_REPORT_ID, ReportIdDef.DATA_SHEET_REPORT_ID];
}
